import React from "react";
import "./performanceInsights.scss";
import images from "../../../../utilities/images/images";

const PerformanceInsights = ({ analytics }) => {
  if (!analytics) return null;

  const {
    accuracy,
    percentile,
    total_correct,
    total_incorrect,
    total_un_attempt,
    total_questions,
    time_quality_report,
  } = analytics;

  const zones = time_quality_report?.zones || [];

  // Strength Criteria
  const strengths = [
    {
      subject: "Accuracy",
      change: `+${accuracy}%`,
      description: `Good accuracy (${accuracy}%). Keep improving!`,
      color: "green",
    },
    {
      subject: "Percentile",
      change: `+${percentile}%`,
      description: `Your percentile score is decent (${percentile}%).`,
      color: "green",
    },
  ];

  // Improvement Areas
  const improvements = [
    {
      subject: "Incorrect Answers",
      change: `-${total_incorrect}`,
      description: `You answered ${total_incorrect} questions incorrectly. Focus on revising these topics.`,
      color: "red",
    },
    {
      subject: "Unattempted Questions",
      change: `-${total_un_attempt}`,
      description: `You left ${total_un_attempt} questions unattempted.`,
      color: "red",
    },
  ];

  // Time Management Insights
  const timeManagement = zones.map((z) => ({
    title: z.zone_name,
    subtitle: z.zone_type,
    percentage: z.percentage,
    description: z.description,
  }));

  return (
    <div className="performance_insights_container">
      {/* Header */}
      <div className="performance_insights_header">
        <img
          src={images.Arrow_Growth_Icon}
          alt="Arrow Growth Icon"
          className="growth_icon"
        />
        <h3 className="performance_insights_title">Performance Insights</h3>
      </div>

      {/* Strengths */}
      <div className="insight_section strengths">
        <h4 className="section_title">
          <img src={images.tick_icon} alt="Tick Icon" className="tick_icon" />
          <span>Your Strengths</span>
        </h4>

        {strengths.map((item, idx) => (
          <div key={idx} className="insight_card green_card">
            <div className="insight_card_header green_header">
              <span className="subject">{item.subject}</span>
              <span className="change positive">{item.change}</span>
            </div>
            <p>{item.description}</p>
          </div>
        ))}
      </div>

      {/* Areas to Improve */}
      <div className="insight_section improve">
        <h4 className="section_title">
          <img
            src={images.improve_icon}
            alt="Improve Icon"
            className="improve_icon"
          />
          <span>Areas to Improve</span>
        </h4>

        {improvements.map((item, idx) => (
          <div key={idx} className="insight_card red_card">
            <div className="insight_card_header red_header">
              <span className="subject">{item.subject}</span>
              <span className="change negative">{item.change}</span>
            </div>
            <p>{item.description}</p>
          </div>
        ))}
      </div>

      {/* Time Management */}
      <div className="insight_section time">
        <h4 className="section_title">
          <img src={images.time_icon} alt="Time Icon" className="time_icon" />
          <span>Time Management</span>
        </h4>

        {timeManagement.map((item, idx) => (
          <div key={idx} className="insight_card yellow_card">
            <div className="insight_card_header yellow_header">
              <span className="subject">{item.title}</span>
              <span className="change">{item.percentage}</span>
            </div>

            <ul>
              <li>{item.subtitle}</li>
              <li>{item.description}</li>
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PerformanceInsights;
